import React from 'react'
import {MenuItem} from './MenuItem'

export function MenuInner() {
  return (
    <>
      <MenuItem title={'Vacancy'} to='/job' />
      <MenuItem title='Resources' to='/resource' />
      <MenuItem title='About' to='/about' />
      <MenuItem title='Contact' to='/contact' />
    </>
  )
}
